import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { IGetAddExam } from '../models/action/exam';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();
const _logger = Log.create('Exam-Service');

export class ExamService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetDifficultiesQuestionCountAsync(params: any) {
        return _apiClient.RequestAsync('GET', `api/exam/getDifficultiesQuestionCount?courseId=${params.courseId}`, null, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestAddExamActivityAsync(params: IGetAddExam) {
        let setUrl = 'api/exam/add';
  
        if(params.examData.activityId) {
            setUrl = 'api/exam/edit';
        }
        return _apiClient.RequestAsync('POST', setUrl, params.examData).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestGetExamAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/activity/activitylist', params)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestGetMyExamsAsync(params: any) {
        return _apiClient
            .RequestAsync('GET', 'api/exam/myexams' + '?Skip=' + params.Skip + '&Take=' + params.Take + '&LastActivityId=' + params.lastActivityId, null, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .catch(responseData => {
                return responseData;
            });
    }

    public async RequestGetMyExamMessagesAsync(params: any) {        
        return _apiClient
            .RequestAsync('POST', 'api/exam/getexammessages', params.getExamMessagesParamModel, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .catch(responseData => {
                return responseData;
            });
    }

}
